import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { ShoppingCart, User, Menu, X } from "lucide-react";
import { useAuth, useCart } from "../App";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export const Navbar = () => {
  const { user, login, logout } = useAuth();
  const { cart } = useCart();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const cartItemCount = cart.items.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <nav className="sticky top-0 z-50 bg-white border-b-4 border-black" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link 
            to="/" 
            className="font-heading text-4xl sm:text-5xl tracking-tight hover:text-accent-pink"
            data-testid="logo-link"
          >
            RIKAMI
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link 
              to="/abbigliamento" 
              className="font-body font-semibold text-lg hover:text-accent-pink uppercase"
              data-testid="nav-abbigliamento"
            >
              Abbigliamento
            </Link>
            <Link 
              to="/magliette" 
              className="font-body font-semibold text-lg hover:text-accent-pink uppercase"
              data-testid="nav-magliette"
            >
              Magliette
            </Link>
            <Link 
              to="/felpe" 
              className="font-body font-semibold text-lg hover:text-accent-pink uppercase"
              data-testid="nav-felpe"
            >
              Felpe
            </Link>
            <Link 
              to="/chi-siamo" 
              className="font-body font-semibold text-lg hover:text-accent-pink uppercase"
              data-testid="nav-chi-siamo"
            >
              Chi Siamo
            </Link>
            <Link 
              to="/contatti" 
              className="font-body font-semibold text-lg hover:text-accent-pink uppercase"
              data-testid="nav-contatti"
            >
              Contatti
            </Link>
          </div>

          {/* Actions */}
          <div className="flex items-center space-x-4">
            {/* Cart */}
            <button
              onClick={() => navigate("/cart")}
              className="relative p-2 border-2 border-black hover:bg-accent-yellow hover:shadow-brutal"
              data-testid="cart-button"
            >
              <ShoppingCart size={24} strokeWidth={2.5} />
              {cartItemCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-accent-pink text-white text-xs font-mono font-bold w-6 h-6 flex items-center justify-center border-2 border-black">
                  {cartItemCount}
                </span>
              )}
            </button>

            {/* User Menu */}
            {user ? (
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <button 
                    className="p-2 border-2 border-black hover:bg-accent-blue hover:shadow-brutal"
                    data-testid="user-menu-button"
                  >
                    <User size={24} strokeWidth={2.5} />
                  </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="border-2 border-black rounded-none shadow-brutal bg-white" align="end">
                  <DropdownMenuItem className="font-body cursor-pointer" onClick={() => navigate("/profilo")} data-testid="profile-link">
                    Il Mio Profilo
                  </DropdownMenuItem>
                  {user?.role === "admin" && (
                    <DropdownMenuItem className="font-body cursor-pointer" onClick={() => navigate("/admin")} data-testid="admin-link">
                      Dashboard Admin
                    </DropdownMenuItem>
                  )}
                  <DropdownMenuItem className="font-body cursor-pointer text-red-600" onClick={logout} data-testid="logout-button">
                    Esci
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            ) : (
              <button
                onClick={login}
                className="btn-brutal text-sm"
                data-testid="login-button"
              >
                Accedi
              </button>
            )}

            {/* Mobile Menu Toggle */}
            <button
              className="md:hidden p-2 border-2 border-black hover:bg-accent-yellow"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-toggle"
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t-2 border-black py-4 space-y-4" data-testid="mobile-menu">
            <Link 
              to="/abbigliamento" 
              className="block font-body font-semibold text-lg hover:text-accent-pink uppercase"
              onClick={() => setMobileMenuOpen(false)}
            >
              Abbigliamento
            </Link>
            <Link 
              to="/magliette" 
              className="block font-body font-semibold text-lg hover:text-accent-pink uppercase"
              onClick={() => setMobileMenuOpen(false)}
            >
              Magliette
            </Link>
            <Link 
              to="/felpe" 
              className="block font-body font-semibold text-lg hover:text-accent-pink uppercase"
              onClick={() => setMobileMenuOpen(false)}
            >
              Felpe
            </Link>
            <Link 
              to="/chi-siamo" 
              className="block font-body font-semibold text-lg hover:text-accent-pink uppercase"
              onClick={() => setMobileMenuOpen(false)}
            >
              Chi Siamo
            </Link>
            <Link 
              to="/contatti" 
              className="block font-body font-semibold text-lg hover:text-accent-pink uppercase"
              onClick={() => setMobileMenuOpen(false)}
            >
              Contatti
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};
